import React, { useEffect, useRef, useState } from 'react';
import { Page } from 'src/components';
import {
  Button,
  Container,
  Grid,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  MenuProps,
  Typography,
  withStyles
} from '@material-ui/core';
import LiabilityChartTable from './components/LiabilityChartTable';
// import { Api, ApiResponse } from 'common';
import Api from 'src/services/ApiService';
import { CommonAxiosResponse } from 'src/types';
import LiabilityPagination from './components/LiabilityPagination';
import { LiabilityChequeDialog } from './components/LiabilityChequeDialog';
import { CameraAlt } from '@material-ui/icons';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import TableChartIcon from '@material-ui/icons/TableChart';
// import { CommonAxiosResponse } from 'src/types';

// import { Toolbar } from './components';
// import { LiabilityChartListing } from './components/LiabilityChartListing';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
    marginTop: 3
  }
})((props: MenuProps) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center'
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center'
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    color: theme.palette.text.primary
  }
}))(MenuItem);

export type SupplierWeeklyData = {
  supplier: string;
  weeks: {
    [weekRange: string]: string; // e.g., "Jul 26 - Aug 01": "1500000"
  };
  total_amount: number;
};
interface Ref {
  capture: () => void;
}

type LiabilityChartResponse = {
  success?: boolean;
  data?: SupplierWeeklyData[];
};

const LiabilityChartView = () => {
  const tableRef = useRef<Ref>(null);

  const [liabilityChart, setLiabilityChart] = React.useState<
    SupplierWeeklyData[]
  >([]);
  const [page, setPage] = useState<number>(0);
  const [isHideZeroValue, setIsHideZeroValue] = useState<boolean>(true); // true by default
  const [isOpenChequeLiability, setIsOpenChequeLiability] = useState<boolean>(
    false
  );
  const [liabilityPayload, settLiabilityPayload] = useState<{
    pdc_date_week?: string;
    supplier_id?: number;
  }>();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // API. Later move to own logic / slice / redux

  const getLiabilityChart = (
    payload: { page: number } // later define proper type
  ): any => {
    return Api.get(`po/liability/chart/get`, payload);
  };

  const fetchLiabilityData = async (currentPage: number) => {
    // api.ts this later
    try {
      const response: CommonAxiosResponse<LiabilityChartResponse> = await getLiabilityChart(
        { page: currentPage }
      );
      // const response: any = await getLiabilityChart({ page: 0 });

      console.log('Response from getLiabilityChart:', response);

      if (response?.originalData?.data) {
        // Handle successful response

        console.log(
          'Liability data fetched successfully:',
          response?.originalData?.data
        );

        let liabilityDataRes = response?.originalData?.data;
        liabilityDataRes = liabilityDataRes?.map((supplier) => {
          const convertedWeeks: any = {};
          for (const [week, value] of Object.entries(supplier?.weeks)) {
            // Remove commas and convert to float
            convertedWeeks[week] = parseFloat(value.replace(/,/g, ''));
          }

          return {
            ...supplier,
            weeks: convertedWeeks
          };
        });

        setLiabilityChart(liabilityDataRes); // Assuming response.data is the array of liabilities
        // Populate liability chart table with response data
      } else {
        // Handle error response
        console.error('Error fetching liability data:', response);
      }
    } catch (error) {
      // Handle network or other errors
      console.error('Network error while fetching liability data:', error);
    }
  };

  const renderLiabilityUtilities = () => (
    <>
      <Button
        aria-controls="customized-menu"
        aria-haspopup="true"
        variant="outlined"
        onClick={handleClick}
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        Liability Utilities
        <span
          style={{
            display: 'flex',
            alignItems: 'center',
            paddingBottom: 3,
            marginLeft: 4
          }}
        >
          {anchorEl ? (
            <ExpandLessIcon style={{ fontSize: 20 }} />
          ) : (
            <ExpandMoreIcon style={{ fontSize: 20 }} />
          )}
        </span>
      </Button>

      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <StyledMenuItem
          onClick={() => {
            setIsHideZeroValue(!isHideZeroValue);
            handleClose();
          }}
        >
          <ListItemIcon>
            <TableChartIcon fontSize="small" color="primary" />
          </ListItemIcon>
          <ListItemText
            primary={
              isHideZeroValue ? 'Show 0 Value Weeks' : 'Hide 0 Value Weeks'
            }
          />
        </StyledMenuItem>

        <StyledMenuItem
          onClick={() => {
            tableRef.current?.capture();
            handleClose();
          }}
        >
          <ListItemIcon>
            <CameraAlt fontSize="small" color="primary" />
          </ListItemIcon>
          <ListItemText primary="EXPORT REPORT AS IMAGE" />
        </StyledMenuItem>
      </StyledMenu>
    </>
  );

  useEffect(() => {
    fetchLiabilityData(page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  return (
    <Page title="Liability Chart" className={''}>
      <Container maxWidth={false} style={{ marginTop: '1.5rem' }}>
        <Typography color="textPrimary" gutterBottom variant="h3">
          Liability Chart
        </Typography>

        <Grid container>
          <Grid item xs>
            {renderLiabilityUtilities()}
          </Grid>

          <Grid item xs>
            <LiabilityPagination page={page} setPage={setPage} />
          </Grid>
        </Grid>

        <LiabilityChartTable
          ref={tableRef}
          hideZeroVal={isHideZeroValue}
          liabilityChart={liabilityChart}
          onHandleOpenLiabilityCheque={(
            week?: string,
            supplier_id?: number
          ) => {
            settLiabilityPayload({ pdc_date_week: week, supplier_id });
            setIsOpenChequeLiability(true);
          }}
        />
        <LiabilityChequeDialog
          open={isOpenChequeLiability}
          liabilityPayload={liabilityPayload || {}}
          onClose={() => setIsOpenChequeLiability(false)}
        />
      </Container>
    </Page>
  );
};

export default LiabilityChartView;
